import { operations } from "types/openapi";
import { api } from "./api";
import { ENDPOINTS } from "./endpoints";

type uploadFile = operations["upload"];
type downloadFile = operations["download"];
type allTemplates = operations["findAll"];
type templateType = operations["getByType"];

/**
 * Получение списка шаблонов
 */
export const getAllTemplates = (): Promise<allTemplates["responses"]["200"]["content"]["*/*"]> => {
  return api.get(ENDPOINTS.getAllTemplates());
};

export const getTemplateType = (type: string): Promise<templateType["responses"]["200"]["content"]["*/*"]> => {
  return api.get(ENDPOINTS.getTemplateType(type));
};

/**
 * Загрузка шаблона документа
 */
export const uploadTemplateFile = ({
  type,
  formData,
}: {
  type: string;
  formData: FormData;
}): Promise<uploadFile["responses"]["200"]["content"]["*/*"]> => {
  return api.post(ENDPOINTS.uploadTemplateFile(type), formData);
};

/**
 * Скачать шаблон документа
 */
export const downloadTemplateFile = (type: string): Promise<downloadFile["responses"]["200"]["content"]["*/*"]> => {
  return api.get(ENDPOINTS.downloadTemplateFile(type));
};
